<template>
  <tr>
    <td 
      class="clickable"
      @click="toggleBidDetails"
    >
      <i class="fa fa-angle-down f-s-15 m-r-5" :class="{ 'fa-rotate-180': showBidDetails }" aria-hidden="true" />
    </td>
    <td :class="bidStatus.class">{{ bidStatus.name }}</td>
    <td>{{ bidDateTime }}</td>
    <td>{{ $t(bidRecord.winningBid ? 'YES' : 'NO') }}</td>
    <td>
      <a :href="`/#/dashboard/campaign/${bidRecord.campaignId}`" class="text-underline" target="_blank">
        {{ bidRecord.campaignName }}
      </a>
      <i class="fa fa-external-link m-l-5" aria-hidden="true" />
    </td>
    <td>{{ bidRecord.publisherName }}</td>
    <td>{{ bidAmount }}</td>
  </tr>
</template>

<script>
import 'moment-timezone';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { currencyFormatter } from '@/modules/reporting/components/AgGridUtils';

export default {
  name: 'RtbRecordRow',
  components: {
  },
  filters: {
    currency(value) {
      return currencyFormatter.format(value);
    }
  },
  props: {
    bidRecord: {
      type: Object,
      default: () => {
        return {};
      }
    },
    timeZoneId: {
      type: String,
      default() {
        return moment.tz.guess();
      }
    },
  },
  data() {
    return {
      showBidDetails: false
    }
  },
  computed: {
    bidDateTime() {
      return moment.tz(this.bidRecord?.bidDt, this.timeZoneId).format('MMM DD YYYY, hh:mm:ss A');
    },
    bidAmount() {
      return this.bidRecord.bidAmount ? currencyFormatter.format(this.bidRecord.bidAmount) : 'N/A';
    },
    bidStatus() {
      return {
        class: this.bidRecord?.isZeroBid ? 'red' : 'green',
        name: this.bidRecord?.isZeroBid ? 'Rejected' : 'Accepted'
      }
    }
  },
  created() {
  },
  methods: {
    toggleBidDetails() {
      this.showBidDetails = !this.showBidDetails;
      this.$emit('toggle-bid-details', this.showBidDetails);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>